import { ColorSizeStock } from "../components/OrderForm/interfaces";

const sortSizes = (s: ColorSizeStock[]) => {
  const table = {
    XXXXS: 8,
    XXXS: 9,
    XXS: 10,
    XS: 11,
    S: 12,
    M: 13,
    L: 14,
    XL: 15,
    "2XL": 16,
    "3XL": 17,
    "4XL": 18,
    "5XL": 19,
    "6XL": 20,
    "7XL": 21,
    "S (9-2)": 50,
    "M (2-7)": 51,
    "L (7-11)": 52,
    "XL (12-14)": 53,
    "0": 100,
    "1": 101,
    "1H": 101.5,
    "2": 102,
    "2H": 102.5,
    "3": 103,
    "3H": 103.5,
    "4": 104,
    "4-6": 104,
    "4/6": 104,
    "4H": 104.5,
    "5": 105,
    "5H": 105.5,
    "6": 106,
    "6-12": 106,
    "6H": 106.5,
    "7": 107,
    "7H": 107.5,
    "8": 108,
    "8H": 108.5,
    "9": 109,
    "9H": 109.5,
    "10": 110,
    "10H": 110.5,
    "11": 111,
    "11H": 111.5,
    "12": 112,
    "12H": 112.5,
    "13": 113,
    "13H": 113.5,
    "14": 114,
    "14H": 114.5,
    "15": 115,
    "15H": 115.5,
    "16": 116,
    "18": 118,
    "20": 120,
    "22": 122,
    "24": 124,
    "26": 126,
    "28": 128,
    "30": 130,
    "32": 132,
    "34": 134,
    "36": 136,
    "38": 138,
    "40": 140,
    "42": 142,
    "44": 144,
    "46": 146,
    "48": 148,
    "50": 150,
    "52": 152,
    "54": 154,
    "56": 156,
    "58": 158,
    "72": 172,
    "77": 177,
    "82": 182,
    "87": 187,
    "92": 192,
    "97": 197,
    "102": 202,
    "107": 207,
    "112": 212,
    "117": 217,
    "122": 222,
    "127": 227,
    "132": 232,
    "137": 237,
    "142": 242,
    "147": 243,
    "161": 244,

    "28R": 245,
    "30R": 246,
    "32R": 247,
    "34R": 248,
    "36R": 249,
    "38R": 250,
    "40R": 251,
    "42R": 252,
    "44R": 253,
    "46R": 254,
    "48R": 255,
    "50R": 256,
    "52R": 257,

    "72R": 258,
    "77R": 259,
    "82R": 260,
    "87R": 261,
    "92R": 262,
    "97R": 263,
    "102R": 264,
    "107R": 265,
    "112R": 266,
    "117R": 267,
    "122R": 268,
    "127R": 269,

    "34S": 270,
    "36S": 271,
    "38S": 272,
    "40S": 273,
    "42S": 274,
    "44S": 275,
    "46S": 276,
    "48S": 277,
    "50S": 278,
    "52S": 279,
    "54S": 280,

    "87S": 281,
    "92S": 282,
    "97S": 283,
    "102S": 284,
    "107S": 285,
    "112S": 286,
    "117S": 287,
    "122S": 288,
    "127S": 289,
    "132S": 290,

    Assorted: 291,
    ASSORTED: 292,
    FRE: 293,

    KS: 300,
    YS: 301,
    AS: 302,
    OS: 303,
  };

  const sizes = s.slice();
  for (let i = 0; i < sizes.length; i++) {
    const s = sizes[i].size;
    const p = table[s];
    sizes[i]["index"] = p;
  }

  sizes.sort(function (size1, size2) {
    if (size1.index && size2.index) {
      return size1.index - size2.index;
    } else return 0;
  });
  return sizes;
};

export default sortSizes;
